import { CSSProperties } from 'react'

import classNames from 'classnames'

import { Column } from './const'
import { Icon } from '@/Atomic/Atoms/Icon'
import {
  ControlledCheckbox,
  stateTransition,
} from '@/Atomic/Atoms/Inputs/ControlledCheckbox'
import { StringText } from '@/Atomic/Atoms/StringText'

interface TableHeaderProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
  variant?: Column
  text?: string
  sortable?: boolean
  sortDirection?: 'ASC' | 'DESC'
  onClick?: React.MouseEventHandler<HTMLTableCellElement>
  selectAllRows?: (select?: boolean) => void
  isAllRowsSelected?: () => boolean | undefined
  isAllRowsSelectDisabled?: () => boolean
}

export const TableHeader: React.FC<TableHeaderProps> = (props) => {
  const { className, style, variant, sortable, onClick } = props
  return (
    <th
      className={classNames(
        'data-table-header',
        variant,
        { sortable: sortable },
        className,
      )}
      style={{ ...style }}
      onClick={onClick}
    >
      <Content {...props} />
    </th>
  )
}

const Content: React.FC<TableHeaderProps> = ({
  children,
  variant,
  text,
  sortable,
  sortDirection,
  selectAllRows,
  isAllRowsSelected,
  isAllRowsSelectDisabled,
}) => {
  if (variant === Column.ROWSELECT) {
    return (
      <ControlledCheckbox
        checked={isAllRowsSelected && isAllRowsSelected()}
        disabled={isAllRowsSelectDisabled && isAllRowsSelectDisabled()}
        onChange={() => {
          if (selectAllRows && isAllRowsSelected) {
            selectAllRows(stateTransition(isAllRowsSelected()))
          }
        }}
      />
    )
  }

  return (
    <>
      <StringText value={text}>{children}</StringText>
      {sortDirection === 'ASC' ? (
        <Icon icon="chevron-up" size="sm" />
      ) : sortDirection === 'DESC' ? (
        <Icon icon="chevron-down" size="sm" />
      ) : sortable ? (
        <Icon icon="chevron-up" size="sm" className="sort-placeholder" />
      ) : null}
    </>
  )
}
